import React from "react";
import styled from "styled-components";
import insta from "../insta.png";
import fb from "../fb.png";

const Contact = () => {
  return (
    <ContactWrapper>
      <h1>Contact</h1>
      <ul>
        <li className="phone">
          {" "}
          <a href="tel:0630312628">06 30 31 26 28</a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/profile.php?id=100046448563340"
          >
            <img
              src={fb}
              className="fb"
              alt="Facebook logo"
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/lm.atelier25/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={insta}
              className="insta"
              alt="Instagram logo"
            />
          </a>
        </li>
      </ul>
    </ContactWrapper>
  );
};

export default Contact;

const ContactWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    margin-bottom: 30vh;
    @media (max-width: 768px) {
      margin-bottom: 15vh;
    }
  }
  ul {
    list-style: none;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 60%;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      grid-gap: 10vh;
    }
    .phone {
      cursor: pointer;
      transition: all 0.168s ease-in-out;
    }
    .phone:hover {
      background: linear-gradient(to right, #ded3b7 0%, #8f601a 90%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    li {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 2rem;
      font-weight: 300;

      img {
        width: 30%;
        aspect-ratio: 1/1;
      }
      @media (min-width: 768px) {
        .insta {
          filter: grayscale(1) invert(100%);
          cursor: pointer;
          transition: filter 0.168s ease-in-out;
        }
        .insta:hover {
          filter: grayscale(0) invert(0%);
        }
        .fb {
          filter: grayscale(1) invert(100%);
          cursor: pointer;
          transition: filter 0.168s ease-in-out;
        }
        .fb:hover {
          filter: grayscale(0) invert(0%);
        }
      }
    }
  }
`;
